import React, { useState } from 'react';
import { Button, Dialog, FormHelperText, Grid, Icon, TextField, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Scrollbars from 'rc-scrollbars';
import DialogLoader from '../../../../components/Loader/DialogLoader';
import { InputBaseField } from '../../../../components/InputField/InputField';
import { DraggableComponent, Label } from '../../../../components/UiElements/UiElements';
import { withSnackbar } from '../../../../components/Message/Alert';
import { PostDataAPI } from '../../../../Services/APIService';
import useStyles from '../../addInventory/styles';

const initialState = { cartonId: 0, cartonNo: '', palletNo: '', itemTypeId: null };

function AddCarton({ dialogOpenClose, handleClose, handleSuccessClose, data, itemTypeOptions, showMessage, ...props }) {
    const classes = useStyles();
    const [state, setState] = useState({ ...initialState, ...(data || {}) });
    const [errorCartonNo, setErrorCartonNo] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const isEdit = state.cartonId > 0;
    const displayValue = value => value === '-' || value === null || value === undefined ? '' : value;

    const handleChange = event => {
        const { name, value } = event.target;
        setState(previous => ({ ...previous, [name]: value }));
        if (name === 'cartonNo' && value.trim()) {
            setErrorCartonNo(false);
        }
    };

    const saveCarton = () => {
        if (isLoading) return;
        if (!displayValue(state.cartonNo).trim()) {
            setErrorCartonNo(true);
            return;
        }

        const request = {
            cartonNo: state.cartonNo.trim(),
            palletNo: displayValue(state.palletNo).trim(),
            itemTypeId: state.itemTypeId || null,
        };
        if (isEdit) request.cartonId = state.cartonId;

        setIsLoading(true);
        PostDataAPI(isEdit ? 'deviceinventory/updateCarton' : 'deviceinventory/addCarton', request, true).then(result => {
            setIsLoading(false);
            if (result.success) {
                setState(initialState);
                handleSuccessClose(result.message || (isEdit ? 'Carton updated successfully.' : 'Carton added successfully.'));
            } else {
                showMessage('Error', result.message || 'Error saving carton, please contact administrator', 'error', 3000);
            }
        }).catch(() => {
            setIsLoading(false);
            showMessage('Error', 'Error saving carton, please contact administrator', 'error', 3000);
        });
    };

    return (
        <Dialog classes={{ paper: classes.dialogPaper }} PaperComponent={DraggableComponent} disableBackdropClick disableEscapeKeyDown open={dialogOpenClose} maxWidth="md" {...props}>
            <div className={classes.dialogContent}>
                {isLoading ? <DialogLoader /> : ''}
                <div className={classes.box}>
                    <div className={classes.header} id="draggable-dialog-title">
                        <Typography className={classes.title}>{isEdit ? 'Edit Carton' : 'Add Carton'}</Typography>
                        <Icon className={classes.closeIcon} onClick={isLoading ? undefined : handleClose} color="primary"><CloseIcon /></Icon>
                    </div>
                    <Scrollbars autoHeight autoHeightMax={570}>
                        <div className={classes.content}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                    <Label title="Carton No." size={12} mandatory={true} />
                                    <InputBaseField name="cartonNo" value={displayValue(state.cartonNo)} onChange={handleChange} placeholder="Carton No." type="text" MaxLength={50} IsDisabled={isLoading} />
                                    {errorCartonNo ? <FormHelperText className={classes.errorText}>Please enter carton no.</FormHelperText> : ''}
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                    <Label title="Pallet No." size={12} mandatory={false} />
                                    <InputBaseField name="palletNo" value={displayValue(state.palletNo)} onChange={handleChange} placeholder="Pallet No." type="text" MaxLength={50} IsDisabled={isLoading} />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                    <Label title="Item Type" size={12} mandatory={false} />
                                    <Autocomplete
                                        options={itemTypeOptions || []}
                                        getOptionLabel={option => option.label || ''}
                                        getOptionSelected={(option, value) => option.value === value.value}
                                        value={(itemTypeOptions || []).find(option => option.value === state.itemTypeId) || null}
                                        onChange={(event, option) => setState(previous => ({
                                            ...previous,
                                            itemTypeId: option ? option.value : null,
                                        }))}
                                        disabled={isLoading}
                                        renderInput={params => (
                                            <TextField {...params} placeholder="Select Item Type" variant="outlined" size="small" className={classes.cartonSelect} />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                    </Scrollbars>
                    <div className={classes.footer}>
                        <div className={classes.footerRight}>
                            <Button className={classes.backBtn} disabled={isLoading} onClick={handleClose}>Close</Button>
                            <Button className={classes.changeBtn} disabled={isLoading} onClick={saveCarton}>{isEdit ? 'Update' : 'Add New'}</Button>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
    );
}

export default withSnackbar(AddCarton);
